import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { storeWriteSettingsAdapts, StoreWriteSettingsAdapter } from './store-write-settings.adapter';
import { CopySink } from 'app/model/pipeline/copysink/copysink';
import { AmazonS3WriteSettings } from 'app/model/pipeline/copysink/store-write-settings/amazon-s3-store-write-settings';

@AdapterRegistry.adapter({
    model:  Metamodel.modelFor(AmazonS3WriteSettings),
    asynchronous: true,
    adapts: {
        ...storeWriteSettingsAdapts
    }
})

export class AmazonS3WriteSettingsAdapter extends StoreWriteSettingsAdapter<AmazonS3WriteSettings, Model.StoreWriteSettings> {
    protected override async _toResource(model: AmazonS3WriteSettings): Promise<Model.StoreWriteSettings> {
        const result: Model.StoreWriteSettings = await super._toResource(model);
        StoreWriteSettingsAdapter.toStoreWriteSettingsResource(model, result);
        return result;
    }

    protected override async _toModel(resource: Model.StoreWriteSettings, copySink: CopySink): Promise<AmazonS3WriteSettings> {
        const result = await super._toModel(resource, copySink);
        StoreWriteSettingsAdapter.toStoreWriteSettingsModel(resource, result);
        return result;
    }
}
